import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Modal } from 'components/shared/Modal/Modal'
import { CompetenciesFormFields } from 'components/shared/CompetenciesFormFields/CompetenciesFormFields'
import { CompetencyDescription } from 'components/shared/CompetencyDescription/CompetencyDescription'
import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'
import { useInternalState } from './hooks'
import { DefaultDescription } from 'components/modals/common/JobPositionModal/tabs/Competencies/common/DefaultDescription/DefaultDescription'

import {
  getCategoryOrder,
  getCompetencies,
} from 'components/shared/CompetenciesFormFields/helpers'

import styles from './EditCompetenciesModal.module.scss'
import { useActiveCategory } from 'hooks'

export const EditCompetenciesModal = ({
  onCancel,
  onClose,
  onConfirm,
  skills,
  isOpen,
}) => {
  const {
    state: {
      form: { competencies, control, formState, watch },
      language,
    },
    handlers: { handleCancel, handleClose, handleConfirm },
  } = useInternalState({ skills }, { onCancel, onClose, onConfirm })

  const categories = getCompetencies(competencies.fields, language)
  const categoryOrder = getCategoryOrder(language)

  const {
    output: activeCategory,
    handleOutputChange,
    handleReset,
    hasOutput: hasActiveCategory,
  } = useActiveCategory()

  return (
    <Modal
      className={styles.modal}
      cancelLabel={t`Cancel`}
      confirmLabel={t`Save`}
      title={t`Edit competencies`}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      isConfirmDisabled={R.not(formState.isDirty)}
      {...{ isOpen }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <h3
          className={styles.subtitle}
        >{t`Click on the competence to read more about it`}</h3>
        <div className={styles.skills}>
          <CompetenciesFormFields
            className={styles.competencies}
            order={categoryOrder}
            onClick={handleOutputChange}
            {...{
              activeCategory,
              categories,
              control,
              formState,
            }}
          />
          <aside className={styles.aside}>
            <DetailsCard
              title={hasActiveCategory ? activeCategory : t`About competencies`}
              onBackClick={handleReset}
              hasDefaultState={R.not(hasActiveCategory)}
            >
              {hasActiveCategory ? (
                <CompetencyDescription
                  competencies={
                    R.reduceBy(
                      (acc, { explanation, label, name }, index) => [
                        ...acc,
                        { explanation, index, label, name },
                      ],
                      [],
                      ({ category }) => category,
                      categories,
                    )[activeCategory]
                  }
                />
              ) : (
                <DefaultDescription />
              )}
            </DetailsCard>
          </aside>
        </div>
      </Modal.Content>
      <Modal.Footer />
    </Modal>
  )
}
